module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-index-09abed6a.svg";